import actions from './actions';

export default {
  setError: actions.setError,
  clearError: actions.clearError,
};
